import React from "react";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { Redirect } from "react-router-dom";
import moment from "moment";

const ProjectDetails = props => {
  console.log("props", props.project);
  const { project, auth } = props;
  console.log("project", project);

  if (!auth.uid) return <Redirect to="/signin" />;
  if (project) {
    return (
      <div className="container section project-details">
        <div className="card">
          <div className="card-content">
            <span className="car-title">Project title - {project.title}</span>
            <p>{project.content}}</p>
          </div>
          <div className="card-action grey ligthen-4 white-text">
            <div>
              Posted By: {project.authorFirstName} {project.authorLastname}
            </div>
            <div>Date: {moment(project.createdAt.toDate()).calendar()}</div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="container center">
        <p>Loading Project</p>
      </div>
    );
  }
};

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.match.params.id;
  const projects = state.firestore.data.projects;
  const project = projects ? projects[id] : null;
  return {
    project: project,
    auth: state.firebase.auth
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect([{ collection: "projects" }])
)(ProjectDetails);



// WEBPACK FOOTER //
// ./src/components/projects/ProjectDetails.jsx